import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasoArchivadoPorId,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/casosArchivadoPorId.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  casoArchivadoPorId: any[];
  archivadoCaseId: string;
  FechaHoraFin: string | null;
  processDefinitionIdDisplayName: string;
  processDefinitionIdVersion: string;
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  casoArchivadoPorId: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
  archivadoCaseId: "",
  processDefinitionIdDisplayName: "",
  processDefinitionIdVersion: "",
  FechaHoraFin: "",
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const casoArchivadoPorIdSlice = createSlice({
  name: "casoArchivadoPorId",
  initialState,
  reducers: {
    setCasoArchivadoPorId: (state, action: PayloadAction<any[]>) => {
      state.casoArchivadoPorId = action.payload;
    },
    setArchivadoCaseId: (state, action: PayloadAction<string>) => {
      state.archivadoCaseId = action.payload;
    },
    getCasoArchivadoPorId: (state, action: PayloadAction<any[]>) => {
      state.casoArchivadoPorId = action.payload;
    },
    setCasoId: (state, action: PayloadAction<string>) => {
      state.archivadoCaseId = action.payload;
    },
    setFechaHoraFin: (state, action: PayloadAction<string>) => {
      state.FechaHoraFin = action.payload;
    },
    setClearCasoArchivadoPorId: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setProcessDefinitionIdDisplayName: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.processDefinitionIdDisplayName = action.payload;
    },
    setProcessDefinitionIdVersion: (state, action: PayloadAction<string>) => {
      state.processDefinitionIdVersion = action.payload;
    },
  },
});
export const setBackendCasoArchivadoPorId =
  (caseId: number): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      const response: AxiosResponse = await BackendCasoArchivadoPorId(caseId);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        dispatch(setCasoArchivadoPorId(response.data.Data));
        if (response.data.Data && response.data.Data.length > 0) {
          dispatch(
            setArchivadoCaseId(response.data.Data[0].TicketBase.Caso.toString()),
          );
          dispatch(
            setFechaHoraFin(
              response.data.Data[0].TicketBase.FechaHoraFin.toString(),
            ),
          );
          dispatch(setCasoId(response.data.Data[0].TicketBase.Caso.toString()));
          if (response.data.Data[0].TicketBonita) {
            const ticketBonita = Array.isArray(response.data.Data[0].TicketBonita)
              ? response.data.Data[0].TicketBonita[0]
              : response.data.Data[0].TicketBonita;

            if (ticketBonita?.processDefinitionId) {
              dispatch(
                setProcessDefinitionIdDisplayName(
                  ticketBonita.processDefinitionId.displayName,
                ),
              );
              dispatch(
                setProcessDefinitionIdVersion(
                  ticketBonita.processDefinitionId.version,
                ),
              );
            }
          }
        }
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        // Si el backend devolvió un objeto de respuesta con ResultadoSolicitud !== 200 o Success === false
        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        // La solicitud fue enviada, pero no hubo respuesta
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        // Es un error de red (DNS, etc.) o un error de configuración de la solicitud
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          dispatch(setCasoArchivadoPorId(response.data.Data));
          if (response.data.Data && response.data.Data.length > 0) {
            dispatch(
              setArchivadoCaseId(
                response.data.Data[0].TicketBase.Caso.toString(),
              ),
            );
            dispatch(setCasoId(response.data.Data[0].TicketBase.Caso.toString()));
            dispatch(
              setFechaHoraFin(
                response.data.Data[0].TicketBase.FechaHoraFin.toString(),
              ),
            );
            if (response.data.Data[0].TicketBonita) {
              const ticketBonita = Array.isArray(
                response.data.Data[0].TicketBonita,
              )
                ? response.data.Data[0].TicketBonita[0]
                : response.data.Data[0].TicketBonita;

              if (ticketBonita?.processDefinitionId) {
                dispatch(
                  setProcessDefinitionIdDisplayName(
                    ticketBonita.processDefinitionId.displayName,
                  ),
                );
                dispatch(
                  setProcessDefinitionIdVersion(
                    ticketBonita.processDefinitionId.version,
                  ),
                );
              }
            }
          }
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearCasoArchivadoPorId =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setCasoArchivadoPorId([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setCasoArchivadoPorId,
  setArchivadoCaseId,
  setFechaHoraFin,
  setCasoId,
  getCasoArchivadoPorId,
  setClearCasoArchivadoPorId,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
  setProcessDefinitionIdDisplayName,
  setProcessDefinitionIdVersion,
} = casoArchivadoPorIdSlice.actions;

export default casoArchivadoPorIdSlice.reducer;
